import React, { useEffect, useState } from 'react';
import { BodyS, BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import OTP from 'components/OTP/OTP';
import Button from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import styles from 'assets/jss/material-dashboard-pro-react/views/activeServices/addBillingAccountDialogStyle';
import { makeStyles } from '@material-ui/core/styles';

// @ts-ignore
const useStyles = makeStyles(styles);

const RESEND_DELAY = 1; // minutes

interface IVerificationTabProps {
	otpValue: string;
	setOtpValue: (value: string) => void;
	phoneNumber: string;
	loading: boolean;
	sendOtp: () => void;
	showOtpError: boolean;
	showResendButton?: boolean;
	failure: boolean;
}

const VerificationTab = ({
	otpValue,
	setOtpValue,
	phoneNumber,
	loading,
	sendOtp,
	showOtpError,
	showResendButton,
	failure,
}: IVerificationTabProps) => {
	const [resendVisible, setResendVisible] = useState<boolean>(false);
	const classes = useStyles();

	const resendOtp = (): void => {
		sendOtp();
		setOtpValue('');
	};

	useEffect(() => {
		const timer = setTimeout(() => setResendVisible(true), RESEND_DELAY * 60 * 1000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className={classes.tab}>
			<div className={classes.verificationTabText}>
				<BodyS inline>{translate('active.services.add.billing.account.you.will.receive.password')}</BodyS>{' '}
				<BodySBold inline>{phoneNumber}</BodySBold>
			</div>
			<BodyS>{translate('active.services.add.billing.account.enter.password')}</BodyS>
			<ConditionalRender
				show={loading}
				onFalse={() => (
					<>
						<OTP otpValue={otpValue} setOtpValue={setOtpValue} otpIncorrect={showOtpError} />
						<ConditionalRender
							show={resendVisible || !!showResendButton}
							onTrue={() => (
								<div className={classes.resendText}>
									<BodyS inline>
										{translate('active.services.add.billing.account.have.not.received.text')}
									</BodyS>
									<Button color="tertiary-light" onClick={resendOtp}>
										{translate('active.services.add.billing.account.resend.token')}
									</Button>
								</div>
							)}
						/>
						<ConditionalRender
							show={failure}
							onTrue={() => (
								<BodyS color="danger">
									{translate('active.services.add.billing.account.technical.problems')}
								</BodyS>
							)}
						/>
					</>
				)}
				onTrue={() => <CustomCircularProgress transparent text={translate('loading')} loading />}
			/>
		</div>
	);
};

export default VerificationTab;
